import * as z from "zod/v4";

export const getSegmentCollections = {
  name: "getSegmentCollections" as const,
  input: z.null(),
  output: z.array(
    z.object({
      id: z.string(),
      handle: z.string(),
      title: z.string(),
      productCount: z.number().optional(),
    }),
  ),
};
